import { render, staticRenderFns } from "./MetadataRecordPez.vue?vue&type=template&id=4038024a&scoped=true&"
import script from "./MetadataRecordPez.vue?vue&type=script&lang=js&"
export * from "./MetadataRecordPez.vue?vue&type=script&lang=js&"
import style0 from "./MetadataRecordPez.vue?vue&type=style&index=0&id=4038024a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038024a",
  null
  
)

component.options.__file = "MetadataRecordPez.vue"
export default component.exports